




import { Component, Vue } from "vue-property-decorator";

import { AUTH_LOGOUT } from "@/store/auth/actions";

@Component({})

export default class FirstLogin extends Vue {
  created(){
    this.$store.dispatch(AUTH_LOGOUT);
  }
}
